import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api'; 
import { FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED } from 'actions/updateAutochargeActions';

function* fetchCustomersWithAutochargeDisabled(action) {
  try {
    const response = yield call(API.getCustomersWithAutochargeDisabled, action.payload); 
    yield put({ type: FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED.SUCCESS, payload: response }); 
    action.cb && action.cb(response); 
  } catch (e) {
    yield put({ type: FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED.FAIL, payload: { error: e } }); 
  }
}
function* autocharge() {
  yield takeLatest(FETCH_CUSTOMERS_WITH_AUTOCHARGE_DISABLED.REQUEST, fetchCustomersWithAutochargeDisabled); 
}

export default autocharge;
